import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param schemaModel ServiceSchemaModel
 * @param assetModel AssetModel
 * @param organisationId string
 * @param data Object
 * @return {Promise<any>|Promise}
 */
export default (function (schemaModel, assetModel, organisationId, data) {
    var url = applyPathVariables(EndPoints.SERVICE_ASSET_SCHEMA_ASSIGN, {
        organisationId: organisationId,
        assetId: assetModel.getAssetSerial(),
        schemaId: schemaModel.id
    });
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: data, headers: headers });
    return request.execute();
});
